import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AssetService ,AssetData, LayoutConfigsMap, CellConfig, LayoutConfig} from '../../../../../services/asset/asset.service';


type LayoutKey = 'grid9' | 'grid4' | 'grid2' | 'gridH';

interface CurrentPlayer { layoutKey: LayoutKey; playerIndex: number; }
declare var PubNub: any;
const VALID_ACTIONS = ['start', 'stream', 'weather', 'technical', 'stop', 'clear'];
type ActionT = typeof VALID_ACTIONS[number];


@Component({
  selector: 'app-asset-config',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AssetConfigComponent implements OnInit,OnDestroy {

  // state
  asset: AssetData;
  layoutConfigs: LayoutConfigsMap;

  layoutStates: { grid9: boolean; grid4: boolean; grid2: boolean; gridH: boolean } = {
    grid9: true, grid4: true, grid2: true, gridH: true
  };

  
  // stats
  totalLayouts = 4;
  enabledLayouts = 4;
  configuredStreams = 0;
  lastUpdated = '--';

  isLive = false;
  currentOverlay: 'stream' | 'technical' | 'weather' | null = null;
  isStarting = false;
  isStopping = false;
  pubnub: any = null;
  pubnubReady = false;
  pubnubListenerRef: any = null;
  activeAction: ActionT = 'start';
  lastTokenProcessed = '';
  lastAppliedAction = '';
  lastAppliedAt = 0;

  // popups
  showConfigPopup = false;
  showAssetEditPopup = false;
  currentPlayer: CurrentPlayer | null = null;

  // config form (cell)
  form_camIndex: number | null = null;
  form_width = '';
  form_height = '';
  form_x = '';
  form_y = '';

  // asset edit temp
  tmpAsset: AssetData;
  assetPath: any;
  stream_data:any; 

  constructor(private svc: AssetService,private activatedRoute:ActivatedRoute,private toastrService:ToastrService) {}

  get isLiveContent(): boolean {
    return this.asset && this.asset.contentType === 'live';
  }

  ngOnInit() {
    this.layoutConfigs = this.svc.getdefaultLayouts();
    this.updateStats();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.assetPath = params['id'];
      this.editAssetInfo(this.assetPath);
     // this.asset = this.svc.getAssetData(this.assetPath);

  });


  this.svc.getConfig(this.assetPath).subscribe((data => {
    console.log("data",data.data.asset_id)
    if(data.data.asset_id){
    this.stream_data = JSON.parse(data.data.config_data)
    let asset_data = this.stream_data

    this.asset = asset_data
    console.log("this.asset",this.stream_data)
    this.asset.id = this.assetPath
    this.tmpAsset = {
      id: this.assetPath,
      videoUrl: this.asset.videoUrl,
      video_H_Url: this.asset.video_H_Url,
      video_dual_Url: this.asset.video_dual_Url,
      video_quad_Url: this.asset.video_quad_Url,
      audiourl: this.asset.audiourl,
      programcutUrl: this.asset.programcutUrl,
      streamUrls: this.asset.streamUrls,
      Program:this.asset.Program,
      contentType: this.asset.contentType,
      signalChannel: this.asset.signalChannel,
      chatEnabled: this.asset.chatEnabled,
      chatChannel: this.asset.chatChannel,
      multiViewEnabled:this.asset.multiViewEnabled

    };
    this.svc.setAssetData(this.tmpAsset);
    this.svc.setLayouts(asset_data.layoutConfigs);
    this.layoutConfigs = asset_data.layoutConfigs;
    this.maybeInitPubNub();

  } else {
    this.asset = this.svc.getAssetData(this.assetPath);
    this.maybeInitPubNub();

  }
  }));

  }

  ngOnDestroy() {
    console.log('Layout page destroyed — clearing localStorage');
    this.svc.clearLayoutAndAsset();
  }

  maybeInitPubNub() {
    if (!this.asset || this.asset.contentType !== 'live') {
      this.applyActionState('start'); // default
      return;
    }
    var ch = (this.asset.signalChannel || '').trim();
    if (!ch) return;
  
    // If already init’d to the same channel, skip
    if (this.pubnub && this.pubnubReady && this.pubnub.__channel === ch) return;
  
    // Tear down previous (if any)
    if (this.pubnub) {
      try {
        if (this.pubnubListenerRef) this.pubnub.removeListener(this.pubnubListenerRef);
        if (this.pubnub.__channel) this.pubnub.unsubscribe({ channels: [this.pubnub.__channel] });
      } catch (_) {}
    }
  
    // Init
    this.pubnub = new PubNub({
      publishKey: 'pub-c-61be60a0-f004-4c1d-8afd-58ba45281614',
      subscribeKey: 'sub-c-15859c61-2a14-48e3-adbb-81b39c3e53e0',
      uuid: 'Volta_live' // UUID
    });
    this.pubnub.__channel = ch;
    var self = this;
  
    // Single listener instance we can remove later
    this.pubnubListenerRef = {
      // Handle only persisted overlay messages for state; ignore signals to avoid doubles
      message: function(mev: any) {
        var msg = mev && mev.message ? mev.message : null;
        var token = mev && mev.timetoken ? String(mev.timetoken) : '';
        var publisher = mev && mev.publisher ? String(mev.publisher) : '';
  
        // ignore our own echo
        if (publisher === self.pubnub.getUUID()) return;
  
        // de-dup by timetoken
        if (token && token === self.lastTokenProcessed) return;
        self.lastTokenProcessed = token;
  
        if (!msg || msg.type !== 'overlay') return;
        var act = (msg.action || '').toString().toLowerCase();
  
        // accept known actions only
        var known = false;
        for (var i=0;i<VALID_ACTIONS.length;i++) if (act === VALID_ACTIONS[i]) { known = true; break; }
        if (!known) return;
  
        // drop rapid duplicates
        if (act === self.lastAppliedAction && (Date.now() - self.lastAppliedAt) < 800) return;
  
        self.applyActionState(act as ActionT);
      },
      status: function(st: any) {
        // optional: log PNConnectedCategory, etc.
      }
    };
  
    this.pubnub.addListener(this.pubnubListenerRef);
    this.pubnub.subscribe({ channels: [ch] });
    this.pubnubReady = true;
  
    // Fetch last persisted overlay (history) once
    this.fetchAndApplyLastAction();
  }
  
  fetchAndApplyLastAction() {
    if (!this.pubnub || !this.asset || !this.asset.signalChannel) {
      this.applyActionState('start');
      return;
    }
    var ch = this.asset.signalChannel;
    var self = this;
  
    this.pubnub.fetchMessages({ channels: [ch], count: 25 }, function(status: any, resp: any) {
      if (status && status.error) {
        console.warn('fetchMessages error', status);
        self.applyActionState('start');
        return;
      }
      var arr = resp && resp.channels && resp.channels[ch] ? resp.channels[ch] : [];
      // newest -> oldest
      for (var i = arr.length - 1; i >= 0; i--) {
        var itm = arr[i];
        var msg = itm && itm.message ? itm.message : null;
        if (!msg || msg.type !== 'overlay') continue;
        var act = (msg.action || '').toString().toLowerCase();
        for (var k=0;k<VALID_ACTIONS.length;k++) {
          if (act === VALID_ACTIONS[k]) {
            self.applyActionState(act as ActionT);
            return;
          }
        }
      }
      self.applyActionState('start'); // default if none found
    });
  }
  
  
  applyActionState(action: string) {
    // normalize
    var a = (action || '').toLowerCase();
    // default unknown -> start
    var known = false;
    for (var i = 0; i < VALID_ACTIONS.length; i++) {
      if (a === VALID_ACTIONS[i]) { known = true; break; }
    }
    if (!known) a = 'start';
  
    // reset overlay unless we set it below
    this.currentOverlay = null;
  
    switch (a) {
      case 'start':
        this.isLive = true;
        break;
      case 'stop':
        this.isLive = false;
        break;
      case 'stream':
      case 'weather':
      case 'technical':
        // overlays don't force live on/off; keep last isLive
        this.currentOverlay = a as any;
        break;
      case 'clear':
        // explicitly no overlay
        break;
    }
  
    this.activeAction = a as any;
  }
  
  

    sendOverlayAction(action: string) {
      // update local immediately for snappy UI
      this.applyActionState(action);
    
      if (!this.pubnub || !this.isLiveContent) return;
      var channelName = this.asset.signalChannel;
    
      try {
        this.pubnub.signal(
          { channel: channelName, message: { action: action } },
          function(status: any, _resp: any) { if (status && status.error) console.error('signal error', status); }
        );
        this.pubnub.publish(
          { channel: channelName, message: { type: 'overlay', action: action } },
          function(status: any, _resp: any) { if (status && status.error) console.error('publish error', status); }
        );
      } catch (e) {
        console.error('PubNub send error', e);
      }
    }
    
    toggleDisplay(action: 'stream'|'weather'|'technical') {
      if (!this.isLiveContent) return;
    
      // toggle off if already selected
      if (this.currentOverlay === action) {
        this.applyActionState('clear');
        this.sendOverlayAction('clear');
        return;
      }
    
      // activate new overlay
      this.applyActionState(action);
      this.sendOverlayAction(action);
    }
    
    async startStream() {
      if (!this.isLiveContent) return;
      this.isStarting = true;
      this.applyActionState('start');
      this.sendOverlayAction('start');
      try {
        await new Promise(function(res){ setTimeout(res, 600); });
      } finally {
        this.isStarting = false;
      }
    }
    
    async stopStream() {
      if (!this.isLiveContent) return;
      this.isStopping = true;
      this.applyActionState('stop');
      this.sendOverlayAction('stop');
      try {
        await new Promise(function(res){ setTimeout(res, 600); });
      } finally {
        this.isStopping = false;
      }
    }
    
  
    // Remote updates come here
    handleRemoteOverlayChange(action: string) {
      if (action === 'start') {
        this.isLive = true;
        return;
      }
      if (action === 'stop') {
        this.isLive = false;
        return;
      }
      if (action === 'clear') {
        this.currentOverlay = null;
        return;
      }
      if (action === 'stream' || action === 'technical' || action === 'weather') {
        this.currentOverlay = action as any;
      }
    }
  
  

  // -------- Mapping helpers (same as your JS) --------
  getPlayerIndexFromColumnCell(layoutKey: LayoutKey, colIndex: number, cellIndex: number): number {
    if (layoutKey === 'grid9') return cellIndex * 3 + colIndex;
    if (layoutKey === 'grid4') return colIndex * 2 + cellIndex;
    if (layoutKey === 'grid2') return colIndex;
    if (layoutKey === 'gridH') {
      const mapping: number[][] = [[0, 1, 2, 3], [8], [4, 5, 6, 7]];
      return mapping[colIndex][cellIndex];
    }
    return 0;
  }

  getColumnCellFromPlayerIndex(layoutKey: LayoutKey, playerIndex: number): { colIndex: number; cellIndex: number } {
    if (layoutKey === 'grid9') {
      // row-major: 0..8 as TL→TR, then next rows
      return { colIndex: playerIndex % 3, cellIndex: Math.floor(playerIndex / 3) };
    } 
    if (layoutKey === 'grid4') return { colIndex: Math.floor(playerIndex / 2), cellIndex: playerIndex % 2 };
    if (layoutKey === 'grid2') return { colIndex: playerIndex, cellIndex: 0 };
    if (layoutKey === 'gridH') {
      const mapping: { [k: number]: [number, number] } = {
        0: [0, 0], 1: [0, 1], 2: [0, 2], 3: [0, 3],
        8: [1, 0],
        4: [2, 0], 5: [2, 1], 6: [2, 2], 7: [2, 3]
      };
      return { colIndex: mapping[playerIndex][0], cellIndex: mapping[playerIndex][1] };
    }
    return { colIndex: 0, cellIndex: 0 };
  }

  initializeLayoutStructure(layoutKey: LayoutKey) {
    const layout = this.layoutConfigs[layoutKey] ? this.layoutConfigs[layoutKey].layout : null;
    if (!layout || layout.length === 0) {
      if (layoutKey === 'grid9') this.layoutConfigs[layoutKey].layout = [[], [], []];
      else if (layoutKey === 'grid4') this.layoutConfigs[layoutKey].layout = [[], []];
      else if (layoutKey === 'grid2') this.layoutConfigs[layoutKey].layout = [[], []];
      else if (layoutKey === 'gridH') this.layoutConfigs[layoutKey].layout = [[], [], []];
    }
  }

  // -------- Template helpers (keep HTML simple) --------
  getCell(layoutKey: LayoutKey, playerIndex: number): CellConfig | null {
    const pos = this.getColumnCellFromPlayerIndex(layoutKey, playerIndex);
    const layoutCfg = this.layoutConfigs[layoutKey];
    const layoutArr = layoutCfg && layoutCfg.layout ? layoutCfg.layout : [];
    const col = layoutArr[pos.colIndex] || [];
    const cell = col[pos.cellIndex];
    return cell ? cell : null;
  }

  isConfigured(layoutKey: LayoutKey, playerIndex: number): boolean {
    const cell = this.getCell(layoutKey, playerIndex);
    return !!(cell && (cell as any).camIndex !== undefined);
  }

  labelFor(layoutKey: LayoutKey, playerIndex: number, base: string): string {
    const cell = this.getCell(layoutKey, playerIndex);
    if (cell && (cell as any).camIndex !== undefined) {
      return `${base} ${(cell as any).camIndex + 1}`; // ✅ display +1
    }
    return `${base} ${playerIndex + 1}`;              // unconfigured: show slot as +1 too
  }
  
  

  // -------- Toggles / Stats --------
  onToggleLayout(layoutKey: LayoutKey, enabled: boolean) {
    this.layoutStates[layoutKey] = enabled;
    this.updateStats();
  }

  updateStats() {
    // enabled
    let enabled = 0;
    for (const k in this.layoutStates) {
      if (this.layoutStates.hasOwnProperty(k) && (this.layoutStates as any)[k]) enabled++;
    }
    // configured cells
    let configured = 0;
    const layouts = this.layoutConfigs;
    for (const key in layouts) {
      if (layouts.hasOwnProperty(key)) {
        const lcfg = (layouts as any)[key] as LayoutConfig;
        if (lcfg && lcfg.layout) {
          for (let i = 0; i < lcfg.layout.length; i++) {
            const col = lcfg.layout[i];
            for (let j = 0; j < col.length; j++) {
              const cell = col[j];
              if (cell && (cell as any).camIndex !== undefined) configured++;
            }
          }
        }
      }
    }
    this.enabledLayouts = enabled;
    this.configuredStreams = configured;
    this.lastUpdated = new Date().toLocaleTimeString();
  }

  // -------- Config popup (cell) --------
  openConfigPopup(layoutKey: LayoutKey, playerIndex: number) {
    if (!this.layoutStates[layoutKey]) return;
  
    this.currentPlayer = { layoutKey, playerIndex };
    const pos = this.getColumnCellFromPlayerIndex(layoutKey, playerIndex);
    this.initializeLayoutStructure(layoutKey);
  
    const layoutArr = this.layoutConfigs[layoutKey].layout;
    const col = layoutArr[pos.colIndex] || [];
    const existing = col[pos.cellIndex];
  
    // ✅ Show 1-based value to the user
    this.form_camIndex = (existing && (existing as any).camIndex != null)
      ? (existing as any).camIndex + 1
      : null;
  
    this.form_width  = (existing && (existing as any).width)  ? (existing as any).width  : '';
    this.form_height = (existing && (existing as any).height) ? (existing as any).height : '';
    this.form_x      = (existing && (existing as any).x)      ? (existing as any).x      : '';
    this.form_y      = (existing && (existing as any).y)      ? (existing as any).y      : '';
  
    this.showConfigPopup = true;
  }
  

  closeConfigPopup() {
    this.showConfigPopup = false;
    this.currentPlayer = null;
  }

  submitConfig() {
    if (!this.currentPlayer) return;
  
    // Read the raw input as string so we can detect 'o'/'O' and '0'
    var raw = (this.form_camIndex !== null && this.form_camIndex !== undefined)
                ? String(this.form_camIndex).trim()
                : '';
  
    var layoutKey = this.currentPlayer.layoutKey;
    var playerIndex = this.currentPlayer.playerIndex;
    var pos = this.getColumnCellFromPlayerIndex(layoutKey, playerIndex);
  
    this.initializeLayoutStructure(layoutKey);
    var layoutArr = this.layoutConfigs[layoutKey].layout;
    var col = layoutArr[pos.colIndex];
  
    // --- Case 1: Unconfigure if user typed 'o', 'O', or '0'
    if (raw.toLowerCase() === 'o' || raw === '0') {
      // Clear the cell (removes camIndex, width, height, x, y)
      while (col.length <= pos.cellIndex) col.push(null as any);
      col[pos.cellIndex] = null as any;
  
      // Persist + close + update stats; no warning
      this.svc.setLayouts(this.layoutConfigs);
      this.closeConfigPopup();
  
      // Optional: reset form fields for next time
      this.form_camIndex = null;
      this.form_width = '';
      this.form_height = '';
      this.form_x = '';
      this.form_y = '';
  
      this.updateStats();
      return;
    }
  
    // --- Case 2: Normal assignment flow (expects 1..9 and all fields filled)
    var userFacing = Number(raw); // user types 1..9
    if (
      isNaN(userFacing) || userFacing < 1 || userFacing > 9 ||
      !this.form_width || !this.form_height || !this.form_x || !this.form_y
    ) {
      // Keep your existing warning for truly invalid inputs
      if ((this as any).toastrService && (this as any).toastrService.warning) {
        this.toastrService.warning('Please enter Camera Index 1–9 and fill all fields');
      } else {
        alert('Please enter Camera Index 1–9 and fill all fields');
      }
      return;
    }
  
    // Convert to zero-based for storage
    var camIndex = userFacing - 1;
  
    while (col.length <= pos.cellIndex) col.push(null as any);
    col[pos.cellIndex] = {
      camIndex: camIndex,
      width: this.form_width,
      height: this.form_height,
      x: this.form_x,
      y: this.form_y
    };
  
    this.svc.setLayouts(this.layoutConfigs);
    this.closeConfigPopup();
  
    // Optional: reset form fields for next time
    this.form_camIndex = null;
    this.form_width = '';
    this.form_height = '';
    this.form_x = '';
    this.form_y = '';
  
    this.updateStats();
  }
  
  

  // -------- Asset edit popup --------
  editAssetInfo(assetPath) {
    const existing = this.svc.defaultAssetData(assetPath);
    const streams = existing.streamUrls ? existing.streamUrls.slice(0) : [];
    while (streams.length < 9) streams.push({ name: 'Camera ' + (streams.length + 1), url: '' });
    console.log(existing,assetPath)
    this.tmpAsset = {
      id: existing.id,
      videoUrl: existing.videoUrl,
      video_H_Url: existing.video_H_Url,
      video_dual_Url: existing.video_dual_Url,
      video_quad_Url: existing.video_quad_Url,
      audiourl: existing.audiourl,
      programcutUrl: existing.programcutUrl,
      streamUrls: streams,
      Program:existing.Program,
      contentType: existing.contentType,
      signalChannel: existing.signalChannel,
      chatEnabled: existing.chatEnabled,
      chatChannel: existing.chatChannel,
      multiViewEnabled:existing.multiViewEnabled
    };
    console.log("asdasd",this.tmpAsset)

  }

  openeditAssetPopup(){ this.showAssetEditPopup = true; }

  closeAssetEditPopup() { this.showAssetEditPopup = false; }

  saveAssetInfo() {
    if (this.tmpAsset.contentType === 'live') {
      if (!this.tmpAsset.signalChannel || !this.tmpAsset.signalChannel.trim()) {
        alert('Signal channel is required for LIVE content.');
        return;
      }
    }
    if (this.tmpAsset.chatEnabled) {
      if (!this.tmpAsset.chatChannel || !this.tmpAsset.chatChannel.trim()) {
        alert('Chat channel is required when Chat is enabled.');
        return;
      }
    }
 
    this.svc.setAssetData(this.tmpAsset);
    this.asset = this.svc.getAssetData(this.assetPath);


    const has = (s?: string) => !!(s && s.trim().length > 0);

    const grid9Enabled = has(this.asset.videoUrl);
    const gridHEnabled = has(this.asset.video_H_Url);
    const grid2Enabled = has(this.asset.video_dual_Url);
    const grid4Enabled = has(this.asset.video_quad_Url);
  
    this.layoutStates.grid9 = grid9Enabled;
    this.layoutStates.gridH  = gridHEnabled;
    this.layoutStates.grid2  = grid2Enabled;
    this.layoutStates.grid4  = grid4Enabled;


    this.maybeInitPubNub();

    this.closeAssetEditPopup();
  }

  // -------- Export / Backend --------
  generateBackendJSON() {
    return this.svc.generateBackendJSON(this.layoutConfigs,this.assetPath);
  }

  exportConfig() {
    const data = this.generateBackendJSON();
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = (window.URL || (window as any).webkitURL).createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'stream-config-export.json';
    a.click();
    setTimeout(function () {
      (window.URL || (window as any).webkitURL).revokeObjectURL(url);
    }, 0);
  }

  sendToBackend() {
    let config = this.generateBackendJSON();
    config.asset_id = this.assetPath,
    this.svc.sendConfig(config).subscribe(
      () => { this.toastrService.success('Configuration saved successfully!'); this.ngOnInit() },
      (err) => { console.error(err); this.toastrService.warning('Failed to send configuration.'); }
    );
  }

  resetAll() {
    if (!confirm('Reset all configurations?')) return;
    this.svc.clearLayoutAndAsset()
    this.layoutConfigs = this.svc.getdefaultLayouts();
    this.layoutStates.grid9 = true;
    this.layoutStates.grid4 = true;
    this.layoutStates.grid2 = true;
    this.layoutStates.gridH = true;

    this.svc.setLayouts(this.layoutConfigs);
    this.updateStats();
    this.toastrService.success('All configurations reset!');
  }


  remove() {
    if (!confirm('Reset all configurations?')) return;
    this.svc.clearLayoutAndAsset()
    this.layoutConfigs = this.svc.getLayouts();
    this.layoutStates.grid9 = true;
    this.layoutStates.grid4 = true;
    this.layoutStates.grid2 = true;
    this.layoutStates.gridH = true;

    this.svc.setLayouts(this.layoutConfigs);
    this.updateStats();
    this.toastrService.success('All configurations removed!');
  }

  // -------- Global key handlers --------
  @HostListener('document:keydown', ['$event'])
  onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      if (this.showConfigPopup) this.closeConfigPopup();
      if (this.showAssetEditPopup) this.closeAssetEditPopup();
    }
  }
}
